<template>
  <div v-if="isCheckSize" class="popFixed">
    <div class="masking" @click="CheckSize" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>图片过大，请上传小于5m照片！</p>
      </div>
      <div class="btnCon only">
        <span @click="CheckSize">我知道了</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckSize',
  data() {
    return {
      isCheckSize: true
    }
  },
  methods: {
    CheckSize() {
      this.isCheckSize = !this.isCheckSize
    }
  }
}
</script>
